/**
 * web/src/api/me.ts
 * Typed client for GET /api/me. Server contract: src/api/me.ts.
 * Returns the authenticated user's profile; 401 on missing/expired session
 * triggers the queryClient's global redirect to /login?expired=1.
 */
import { api } from '../lib/api';
import type { Me } from './types';

/**
 * Fetches the current authenticated user.
 * @returns Me — { id, email, name, role }
 * @throws ApiClientError(401) when the session is missing/expired
 * @sideEffects performs an HTTP GET with credentials: 'include'
 * @idempotent yes
 */
export async function fetchMe(): Promise<Me> {
  return api<Me>('/api/me');
}
